// import React, { useState, useEffect } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import {
//   Calendar, Filter, Search, Download, ChevronLeft, ChevronRight,
//   Clock, User, Hash, CheckCircle, XCircle, AlertCircle,
//   Loader2, FileText, RefreshCw, Eye, EyeOff, History, ChevronDown, ChevronUp,
//   Users, TrendingUp, TrendingDown, Activity, ArrowDown, ArrowUp
// } from 'lucide-react';
// import { Get_Attendance, Get_Attendance_Org } from '../../../services/oprations/Attendance';
// import useSocket from '../../../hooks/useSocket';
// import StandardSpinner from '../../../utils/Spinner';
// import toast from 'react-hot-toast';
// import * as XLSX from 'xlsx';

// const COLUMN_STORAGE_KEY = 'attendance_visible_columns';

// const defaultColumns = {
//   serial: true,
//   date: true,
//   name: true,
//   empCode: true,
//   worktimezone: true,
//   viewtimezone: true,
//   inTime: true,
//   outTime: true,
//   workTime: true,
//   earlyIn: false,
//   lateIn: true,
//   earlyOut: true,
//   lateOut: false,
//   underTime: false,
//   overTime: false,
//   status: true,
// };

// const AttendanceManagement = () => {
//   const dispatch = useDispatch();
//   const socket = useSocket();
//   const { attendance } = useSelector((state) => state.Attendance);
//   const attendances = typeof attendance == 'string' ? JSON.parse(attendance) : attendance;
//   console.log('attendance', attendances);
//   const { user } = useSelector((state) => state.profile);
//   const [loading, setLoading] = useState(false);
//   const [filteredAttendance, setFilteredAttendance] = useState([]);

//   // Helper function to get first day of month
//   const getFirstDayOfMonth = (date) => {
//     const year = date.getFullYear();
//     const month = date.getMonth();
//     return new Date(year, month, 2);
//   };

//   // Filter states
//   const [empId, setEmpId] = useState('All');
//   const [fromDate, setFromDate] = useState(() => {
//     const today = new Date();
//     const firstDay = getFirstDayOfMonth(today);
//     return firstDay.toISOString().split('T')[0];
//   });
//   const [toDate, setToDate] = useState(() => {
//     const now = new Date();
//     const kiritimatiDate = new Intl.DateTimeFormat('en-CA', {
//       timeZone: 'Pacific/Kiritimati',
//       year: 'numeric',
//       month: '2-digit',
//       day: '2-digit',
//     }).format(now);
//     return kiritimatiDate;
//   });

//   // UI states
//   const [showFilters, setShowFilters] = useState(true);
//   const [showExportMenu, setShowExportMenu] = useState(false);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage] = useState(10);
//   const [employeeList, setEmployeeList] = useState([]);
//   const [expandedRows, setExpandedRows] = useState({});
//   const [expandedInOut, setExpandedInOut] = useState({});
//   const [dateSortOrder, setDateSortOrder] = useState('desc'); // 'desc' = newest first, 'asc' = oldest first
//   const [stats, setStats] = useState({
//     total: 0,
//     present: 0,
//     absent: 0,
//     late: 0,
//     earlyOut: 0,
//   });

//   const [showColumnMenu, setShowColumnMenu] = useState(false);

//   // ── Persisted column visibility ──────────────────────────────────────────
//   const [visibleColumns, setVisibleColumns] = useState(() => {
//     try {
//       const saved = localStorage.getItem(COLUMN_STORAGE_KEY);
//       if (saved) {
//         const parsed = JSON.parse(saved);
//         // Only keep keys that still exist in defaultColumns
//         // This prevents stale/removed keys from injecting false values
//         const valid = Object.fromEntries(
//           Object.keys(defaultColumns)
//             .filter(k => k in parsed)
//             .map(k => [k, parsed[k]])
//         );
//         return { ...defaultColumns, ...valid };
//       }
//     } catch {}
//     return { ...defaultColumns };
//   });

//   const toggleColumn = (column) => {
//     setVisibleColumns((prev) => {
//       const updated = { ...prev, [column]: !prev[column] };
//       try {
//         localStorage.setItem(COLUMN_STORAGE_KEY, JSON.stringify(updated));
//       } catch {}
//       return updated;
//     });
//   };
//   // ─────────────────────────────────────────────────────────────────────────

//   useEffect(() => {
//     fetchAttendance();
//   }, [empId, fromDate, toDate]);

//   useEffect(() => {
//     if (attendance && attendance.length > 0) {
//       let filtered = [...attendance].sort((a, b) => {
//         const dateA = a.DateString?.split(' ')[0];
//         const dateB = b.DateString?.split(' ')[0];
//         const dateDiff =
//           dateSortOrder === 'desc'
//             ? new Date(dateB) - new Date(dateA)
//             : new Date(dateA) - new Date(dateB);
//         if (dateDiff !== 0) return dateDiff;
//         return (a.Name || '').localeCompare(b.Name || '', undefined, { sensitivity: 'base' });
//       });

//       if (searchTerm) {
//         filtered = attendance.filter(
//           (item) =>
//             item.Name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//             item.EMP_Code?.toLowerCase().includes(searchTerm.toLowerCase())
//         );
//       }

//       setFilteredAttendance(filtered);

//       const uniqueEmployees = [];
//       const seen = new Set();
//       attendance.forEach((item) => {
//         if (!seen.has(item.EMP_Code)) {
//           seen.add(item.EMP_Code);
//           uniqueEmployees.push({ id: item.EMP_Code, name: item.Name, empCode: item.EMP_Code });
//         }
//       });
//       setEmployeeList(uniqueEmployees);
//       calculateStats(attendance);
//     } else {
//       setFilteredAttendance([]);
//       setEmployeeList([]);
//       setStats({ total: 0, present: 0, absent: 0, late: 0, earlyOut: 0 });
//     }
//   }, [attendance, searchTerm, dateSortOrder]);

//   useEffect(() => {
//     if (!socket) return;
//     socket.on('Attendance_Status', () => {
//       fetchAttendance();
//     });
//     return () => {
//       socket.off('Attendance_Status');
//     };
//   }, [socket]);

//   const fetchAttendance = async () => {
//     setLoading(true);
//     try {
//       await (user?.role === 'Manager'
//         ? dispatch(Get_Attendance(empId, fromDate, toDate))
//         : dispatch(Get_Attendance_Org(empId, fromDate, toDate)));
//     } catch (error) {
//       console.error('Error fetching attendance:', error);
//       toast.error('Failed to fetch attendance data');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const calculateStats = (data) => {
//     const stats = {
//       total: data.length,
//       present: data.filter((item) => item.status === 'P').length,
//       absent: data.filter((item) => item.status === 'A' || !item.IN_Time).length,
//       late: data.filter((item) => parseFloat(item.Late_In) > 0).length,
//       earlyOut: data.filter((item) => parseFloat(item.Erl_Out) > 0).length,
//     };
//     setStats(stats);
//   };

//   const handleRefresh = () => {
//     fetchAttendance();
//   };

//   // ======================= Export Helpers =======================
//   const prepareExportData = () => {
//     const headers = [
//       'Date', 'Name', 'ID', 'Status', 'Work Offset', 'View TimeZone',
//       'First IN Time', 'Last OUT Time', 'Work Time', 'Early In',
//       'Late In', 'Early Out', 'Late Out', 'Under Time', 'Over Time', 'IN/OUT Times',
//     ];

//     const rows = filteredAttendance.map((item) => {
//       const inoutStr = item.INOUT_Times?.length
//         ? item.INOUT_Times.map((r) => `${r.type}: ${r.time}`).join(' ; ')
//         : '';
//       return [
//         item.DateString || '',
//         item.Name || '',
//         item.EMP_Code || '',
//         item.status === 'P' ? 'Present' : 'Absent',
//         item.WorkTimeZone || '',
//         item.ViewTimeZone || '',
//         item.IN_Time || '--:--:--',
//         item.OUT_Time || '--:--:--',
//         item.Work_Time || '00:00:00',
//         item.Early_In || '00:00:00',
//         item.Late_In || '00:00:00',
//         item.Erl_Out || '00:00:00',
//         item.Late_Out || '00:00:00',
//         item.Under_Time || '00:00:00',
//         item.Over_Time || '00:00:00',
//         inoutStr,
//       ];
//     });

//     return { headers, rows };
//   };

//   const handleExportCSV = () => {
//     const { headers, rows } = prepareExportData();
//     const escape = (val) => `"${String(val).replace(/"/g, '""')}"`;
//     const csv = [headers, ...rows].map((row) => row.map(escape).join(',')).join('\n');
//     const blob = new Blob([csv], { type: 'text/csv' });
//     const url = window.URL.createObjectURL(blob);
//     const a = document.createElement('a');
//     a.href = url;
//     a.download = `attendance_${fromDate}_to_${toDate}.csv`;
//     a.click();
//     window.URL.revokeObjectURL(url);
//     setShowExportMenu(false);
//     toast.success('Exported as CSV successfully');
//   };

//   const handleExportExcel = () => {
//     const { headers, rows } = prepareExportData();
//     const worksheetData = [headers, ...rows];
//     const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
//     worksheet['!cols'] = [
//       { wch: 15 }, { wch: 25 }, { wch: 15 }, { wch: 27 }, { wch: 22 },
//       { wch: 22 }, { wch: 12 }, { wch: 12 }, { wch: 12 }, { wch: 12 },
//       { wch: 12 }, { wch: 80 }, { wch: 10 },
//     ];
//     const workbook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(workbook, worksheet, 'Attendance');
//     XLSX.writeFile(workbook, `attendance_${fromDate}_to_${toDate}.xlsx`);
//     setShowExportMenu(false);
//     toast.success('Exported as Excel successfully');
//   };

//   // ======================= UI Helpers =======================
//   const toggleRowExpand = (id) => {
//     setExpandedRows((prev) => ({ ...prev, [id]: !prev[id] }));
//   };

//   const toggleShowAll = (id) => {
//     setExpandedInOut((prev) => ({ ...prev, [id]: !prev[id] }));
//   };

//   // const getStatusBadge = (status, lateIn, earlyOut) => {
//   //   if (status === 'P') {
//   //     const [hours, minutes, seconds] = lateIn.split(":").map(Number);
//   //     const lateTotalSeconds = hours * 3600 + minutes * 60 + seconds;

//   //     const [h, m, s] = earlyOut.split(":").map(Number);
//   //     const earlyOutTotalSeconds = h * 3600 + m * 60 + s;

//   //     // if (parseFloat(lateIn) > 0)
//   //     if (lateTotalSeconds > 0 && earlyOutTotalSeconds === 0) {
//   //       return (
//   //         <span className="px-2 py-1 text-xs font-medium text-yellow-400 rounded-full bg-yellow-500/20 whitespace-nowrap">
//   //           Late
//   //         </span>
//   //       );
//   //     }

//   //     // if (parseFloat(earlyOut) > 0)
//   //     if (earlyOutTotalSeconds > 0) {
//   //       return (
//   //         <span className="px-2 py-1 text-xs font-medium text-orange-400 rounded-full bg-orange-500/20 whitespace-nowrap">
//   //           Early Out
//   //         </span>
//   //       );
//   //     }

//   //     return (
//   //       <span className="px-2 py-1 text-xs font-medium text-green-400 rounded-full bg-green-500/20 whitespace-nowrap">
//   //         Present
//   //       </span>
//   //     );
//   //   }

//   //   return (
//   //     <span className="px-2 py-1 text-xs font-medium text-red-400 rounded-full bg-red-500/20 whitespace-nowrap">
//   //       Absent
//   //     </span>
//   //   );
//   // };

//   // ── Helper functions for date/time formatting ──────────────────────────────

//   const parseDateTime = (dateTimeStr) => {
//     if (!dateTimeStr || dateTimeStr === '--' || dateTimeStr === 'Invalid Date') {
//       return { date: '—', time: '—' };
//     }
    
//     try {
//       // Handle format like "2026-07-01 04:00:03 PM"
//       if (typeof dateTimeStr === 'string' && dateTimeStr.includes(' ')) {
//         const parts = dateTimeStr.split(' ');
//         if (parts.length >= 3) {
//           // parts[0] = "2026-07-01", parts[1] = "04:00:03", parts[2] = "PM"
//           const datePart = parts[0];
//           const timePart = `${parts[1]} ${parts[2]}`;
          
//           // Format date as DD/MM/YYYY
//           const dateObj = new Date(datePart);
//           if (!isNaN(dateObj.getTime())) {
//             const day = String(dateObj.getDate()).padStart(2, '0');
//             const month = String(dateObj.getMonth() + 1).padStart(2, '0');
//             const year = dateObj.getFullYear();
//             const formattedDate = `${day}/${month}/${year}`;
            
//             // Format time as HH:MM:SS AM/PM
//             const timeParts = timePart.split(' ');
//             if (timeParts.length === 2) {
//               const [hourMinSec, ampm] = timeParts;
//               const [hours, minutes, seconds] = hourMinSec.split(':');
//               const hour = parseInt(hours);
//               // Already in 12-hour format from API
//               const hourStr = String(hour).padStart(2, '0');
//               return {
//                 date: formattedDate,
//                 time: `${hourStr}:${minutes}:${seconds} ${ampm}`
//               };
//             }
//           }
//         }
//       }
      
//       // Fallback: try parsing as date
//       const date = new Date(dateTimeStr);
//       if (!isNaN(date.getTime())) {
//         const day = String(date.getDate()).padStart(2, '0');
//         const month = String(date.getMonth() + 1).padStart(2, '0');
//         const year = date.getFullYear();
//         return {
//           date: `${day}/${month}/${year}`,
//           time: date.toLocaleTimeString('en-US', { 
//             hour: '2-digit', 
//             minute: '2-digit',
//             second: '2-digit',
//             hour12: true 
//           })
//         };
//       }
      
//       return { date: '—', time: '—' };
//     } catch {
//       return { date: '—', time: '—' };
//     }
//   };

//   const getStatusBadge = (lateIn, earlyOut, inOutTimes = [], overTime) => {
//     // No punches
//     if (!inOutTimes.length) {
//       return (
//         <span className="px-2 py-1 text-xs font-medium text-red-400 rounded-full bg-red-500/20 whitespace-nowrap">
//           Absent
//         </span>
//       );
//     }

//     if(overTime && overTime !== '00:00:00') {
//       return (
//         <span className="px-2 py-1 text-xs font-medium text-blue-400 rounded-full bg-blue-500/20 whitespace-nowrap">
//           Over Time
//         </span>
//       );
//     }

//     const lateTotalSeconds = lateIn
//       .split(":")
//       .map(Number)
//       .reduce((total, value, index) => {
//         return total + value * [3600, 60, 1][index];
//       }, 0);

//     const earlyOutTotalSeconds = earlyOut
//       .split(":")
//       .map(Number)
//       .reduce((total, value, index) => {
//         return total + value * [3600, 60, 1][index];
//       }, 0);

//     const lastPunchType =
//       inOutTimes[inOutTimes.length - 1]?.type?.toUpperCase();

//     // Employee is currently IN
//     if (lastPunchType === "IN") {
//       if (lateTotalSeconds > 0) {
//         return (
//           <span className="px-2 py-1 text-xs font-medium text-yellow-400 rounded-full bg-yellow-500/20 whitespace-nowrap">
//             Late
//           </span>
//         );
//       }

//       return (
//         <span className="px-2 py-1 text-xs font-medium text-green-400 rounded-full bg-green-500/20 whitespace-nowrap">
//           Present
//         </span>
//       );
//     }

//     // Employee has checked OUT
//     if (lastPunchType === "OUT") {
//       if (lateTotalSeconds > 0 && earlyOutTotalSeconds === 0) {
//         return (
//           <span className="px-2 py-1 text-xs font-medium text-yellow-400 rounded-full bg-yellow-500/20 whitespace-nowrap">
//             Late
//           </span>
//         );
//       }

//       else if (lateTotalSeconds === 0 && earlyOutTotalSeconds > 0) {
//         return (
//           <span className="px-2 py-1 text-xs font-medium text-orange-400 rounded-full bg-orange-500/20 whitespace-nowrap">
//             Early Out
//           </span>
//         );
//       }

//       else if (lateTotalSeconds > 0 && earlyOutTotalSeconds > 0) {
//         return (
//           <span className="px-2 py-1 text-xs font-medium text-orange-200 rounded-full bg-orange-300/20 whitespace-nowrap">
//             Late / Early 
//           </span>
//         );
//       }

//       return (
//         <span className="px-2 py-1 text-xs font-medium text-green-400 rounded-full bg-green-500/20 whitespace-nowrap">
//           Present
//         </span>
//       );
//     }

//     return (
//       <span className="px-2 py-1 text-xs font-medium text-green-400 rounded-full bg-green-500/20 whitespace-nowrap">
//         Present
//       </span>
//     );
//   };

//   const renderINOUTHistory = (inoutTimes) => {
//     if (!inoutTimes || inoutTimes.length === 0) {
//       return <div className="text-xs text-blue-300/50">No IN/OUT records</div>;
//     }

//     const showAll = expandedInOut[inoutTimes[0]?._id] || false;
//     const displayedEntries = showAll ? inoutTimes : inoutTimes.slice(0, 4);
//     const hasMore = inoutTimes.length > 4;

//     return (
//       <div className="space-y-1">
//         {displayedEntries.map((record, idx) => {
//           const time = record?.time;
//           const isIN = record.type === 'IN';
//           return (
//             <div key={idx} className="flex items-center gap-2 text-xs">
//               <div
//                 className={`w-5 h-5 px-3.5 py-1 rounded-full flex items-center justify-center text-[10px] font-medium ${
//                   isIN ? 'bg-green-500/20 text-green-400' : 'bg-red-500/20 text-red-400'
//                 }`}
//               >
//                 {isIN ? 'IN' : 'OUT'}
//               </div>
//               <span className="text-xs text-white">{time}</span>
//             </div>
//           );
//         })}

//         {hasMore && (
//           <button
//             onClick={() => toggleShowAll(inoutTimes[0]?._id)}
//             className="flex items-center gap-1 mt-1 text-xs text-blue-400 hover:text-blue-300"
//           >
//             {showAll ? (
//               <>Show Less <ChevronUp className="w-3 h-3" /></>
//             ) : (
//               <>+{inoutTimes.length - 4} more <ChevronDown className="w-3 h-3" /></>
//             )}
//           </button>
//         )}
//       </div>
//     );
//   };

//   // ======================= Pagination =======================
//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentItems = filteredAttendance.slice(indexOfFirstItem, indexOfLastItem);
//   const totalPages = Math.ceil(filteredAttendance.length / itemsPerPage);

//   if (loading && !attendance) {
//     return <StandardSpinner />;
//   }
   
//   const hiddenCount = Object.keys(defaultColumns).filter(key => !visibleColumns[key]).length;

//   return (
//     <div className="min-h-screen p-3 pt-0 bg-richblue-950 md:p-4 lg:p-6">
//       <div className="mx-auto max-w-7xl">

//         {/* Header */}
//         <div className="flex flex-col gap-4 mb-6 md:flex-row md:items-center md:justify-between">
//           <div>
//             <h1 className="text-2xl font-bold text-transparent bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text md:text-3xl">
//               Attendance Management
//             </h1>
//             <p className="mt-1 text-xs text-blue-200/60 md:text-sm">
//               View and manage employee attendance records with multiple IN/OUT tracking
//             </p>
//           </div>

//           <div className="flex items-center gap-2">
//             {/* Refresh */}
//             <button
//               onClick={handleRefresh}
//               className="p-2.5 bg-white/5 hover:bg-white/10 border border-blue-500/30 rounded-xl text-blue-400 hover:text-blue-300 transition-colors"
//               title="Refresh"
//             >
//               <RefreshCw className={`w-4 h-4 ${loading ? 'animate-spin' : ''}`} />
//             </button>

//             {/* Column Selector */}
//             <div className="relative">
//               <button
//                 onClick={() => setShowColumnMenu((prev) => !prev)}
//                 className="px-3 py-2.5 bg-white/5 hover:bg-white/10 border border-blue-500/30 rounded-xl text-blue-300 flex items-center gap-2 text-sm"
//               >
//                 Columns
//                 {hiddenCount > 0 && (
//                   <span className="inline-flex items-center justify-center w-4 h-4 text-[10px] font-bold text-white bg-blue-500 rounded-full leading-none">
//                     {hiddenCount}
//                   </span>
//                 )}
//                 <ChevronDown className={`w-4 h-4 transition-transform ${showColumnMenu ? 'rotate-180' : ''}`} />
//               </button>

//               {showColumnMenu && (
//                 <>
//                   <div className="fixed inset-0 z-10" onClick={() => setShowColumnMenu(false)} />
//                   <div className="absolute -right-16 z-20 w-56 p-3 mt-2 border rounded-xl bg-[#0a0f2e] border-blue-500/30 shadow-xl">
//                     <div className="space-y-2">
//                       {Object.entries({
//                         serial: 'S.No',
//                         date: 'Date',
//                         name: 'Name',
//                         empCode: 'EMP Code',
//                         worktimezone: 'Work TimeZone',
//                         viewtimezone: 'View Timezone',
//                         inTime: 'IN Time',
//                         outTime: 'OUT Time',
//                         workTime: 'Work Time',
//                         earlyIn: 'Early In',
//                         lateIn: 'Late In',
//                         earlyOut: 'Early Out',
//                         lateOut: 'Late Out',
//                         underTime: 'Under Time',
//                         overTime: 'Over Time',
//                         status: 'Status',
//                       }).map(([key, label]) => (
//                         <label key={key} className="flex items-center gap-2 text-sm text-blue-200 cursor-pointer">
//                           <input
//                             type="checkbox"
//                             checked={visibleColumns[key]}
//                             onChange={() => toggleColumn(key)}
//                           />
//                           {label}
//                         </label>
//                       ))}
//                     </div>
//                   </div>
//                 </>
//               )}
//             </div>

//             {/* Export Dropdown */}
//             <div className="relative">
//               <button
//                 onClick={() => setShowExportMenu((prev) => !prev)}
//                 disabled={filteredAttendance.length === 0}
//                 className="px-3 py-2.5 md:px-4 bg-gradient-to-r from-blue-600 to-cyan-600 hover:from-blue-500 hover:to-cyan-500 text-white font-medium rounded-xl flex items-center gap-2 shadow-lg disabled:opacity-50 disabled:cursor-not-allowed transition-all text-sm md:text-base"
//               >
//                 <Download className="w-4 h-4" />
//                 <span className="hidden sm:inline">Export</span>
//                 <ChevronDown className={`w-4 h-4 transition-transform ${showExportMenu ? 'rotate-180' : ''}`} />
//               </button>

//               {showExportMenu && (
//                 <>
//                   <div className="fixed inset-0 z-10" onClick={() => setShowExportMenu(false)} />
//                   <div className="absolute right-0 mt-2 w-44 z-20 bg-[#0a0f2e] border border-blue-500/30 rounded-xl shadow-2xl overflow-hidden">
//                     <button
//                       onClick={handleExportCSV}
//                       className="flex items-center w-full gap-3 px-4 py-3 text-sm text-blue-200 transition-colors hover:bg-white/10"
//                     >
//                       <FileText className="w-4 h-4 text-blue-400 shrink-0" />
//                       Export as CSV
//                     </button>
//                     <div className="h-px bg-blue-500/20" />
//                     <button
//                       onClick={handleExportExcel}
//                       className="flex items-center w-full gap-3 px-4 py-3 text-sm text-blue-200 transition-colors hover:bg-white/10"
//                     >
//                       <FileText className="w-4 h-4 text-green-400 shrink-0" />
//                       Export as Excel
//                     </button>
//                   </div>
//                 </>
//               )}
//             </div>
//           </div>
//         </div>

//         {/* Stats Cards */}
//         <div className="grid grid-cols-2 gap-3 mb-6 md:grid-cols-5 md:gap-4">
//           <div className="bg-richblue-950 border border-blue-700/80 rounded-xl p-3 md:p-4 shadow-[0_10px_40px_rgba(0,0,0,0.6)]">
//             <div className="flex items-center justify-between">
//               <p className="text-xs text-blue-300 md:text-sm">Total Records</p>
//               <Users className="w-4 h-4 text-blue-400" />
//             </div>
//             <p className="text-xl font-bold text-white md:text-2xl">{stats.total}</p>
//           </div>
//           <div className="bg-richblue-950 rounded-xl p-3 md:p-4 shadow-[0_10px_40px_rgba(0,0,0,0.6)] border border-green-700/40">
//             <div className="flex items-center justify-between">
//               <p className="text-xs text-green-300 md:text-sm">Present</p>
//               <CheckCircle className="w-4 h-4 text-green-400" />
//             </div>
//             <p className="text-xl font-bold text-white md:text-2xl">{stats.present}</p>
//           </div>
//           <div className="bg-richblue-950 rounded-xl p-3 md:p-4 shadow-[0_10px_40px_rgba(0,0,0,0.6)] border border-red-700/40">
//             <div className="flex items-center justify-between">
//               <p className="text-xs text-red-300 md:text-sm">Absent</p>
//               <XCircle className="w-4 h-4 text-red-400" />
//             </div>
//             <p className="text-xl font-bold text-white md:text-2xl">{stats.absent}</p>
//           </div>
//           <div className="bg-richblue-950 rounded-xl p-3 md:p-4 shadow-[0_10px_40px_rgba(0,0,0,0.6)] border border-yellow-700/60">
//             <div className="flex items-center justify-between">
//               <p className="text-xs text-yellow-300 md:text-sm">Late Arrivals</p>
//               <Clock className="w-4 h-4 text-yellow-400" />
//             </div>
//             <p className="text-xl font-bold text-white md:text-2xl">{stats.late}</p>
//           </div>
//           <div className="col-span-2 md:col-span-1 bg-richblue-950 rounded-xl p-3 md:p-4 shadow-[0_10px_40px_rgba(0,0,0,0.6)] border border-orange-500/30">
//             <div className="flex items-center justify-between">
//               <p className="text-xs text-orange-300 md:text-sm">Early Out</p>
//               <TrendingDown className="w-4 h-4 text-orange-400" />
//             </div>
//             <p className="text-xl font-bold text-white md:text-2xl">{stats.earlyOut}</p>
//           </div>
//         </div>

//         {/* Filters Section */}
//         <div className="mb-6 overflow-hidden border shadow-xl bg-gradient-to-br from-blue-900/40 to-indigo-900/40 backdrop-blur-xl rounded-xl border-blue-500/30">
//           <div
//             className="flex items-center justify-between px-4 py-3 border-b cursor-pointer md:px-6 border-blue-500/20"
//             onClick={() => setShowFilters(!showFilters)}
//           >
//             <div className="flex items-center gap-2">
//               <Filter className="w-4 h-4 text-blue-400" />
//               <span className="text-sm font-medium text-white md:text-base">Filters</span>
//             </div>
//             <button className="text-blue-400 hover:text-blue-300">
//               {showFilters ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
//             </button>
//           </div>

//           {showFilters && (
//             <div className="p-4 md:p-6">
//               <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
//                 <div>
//                   <label className="block mb-2 text-xs font-medium text-blue-200 md:text-sm">
//                     <User className="inline w-3 h-3 mr-1 text-blue-400 md:w-4 md:h-4" />
//                     Employee
//                   </label>
//                   <select
//                     value={empId}
//                     onChange={(e) => setEmpId(e.target.value)}
//                     className="w-full px-3 py-2 text-sm bg-white/5 border border-blue-500/30 rounded-xl focus:outline-none focus:border-blue-400 text-white md:px-4 md:py-2.5"
//                   >
//                     <option value="All" className="bg-[#0a0f1e]">All Employees</option>
//                     {employeeList.map((emp) => (
//                       <option key={emp.id} value={emp.id} className="bg-[#0a0f1e]">
//                         {emp.name} ({emp.empCode})
//                       </option>
//                     ))}
//                   </select>
//                 </div>

//                 <div>
//                   <label className="block mb-2 text-xs font-medium text-blue-200 md:text-sm">
//                     <Calendar className="inline w-3 h-3 mr-1 text-blue-400 md:w-4 md:h-4" />
//                     From Date
//                   </label>
//                   <input
//                     type="date"
//                     value={fromDate}
//                     onChange={(e) => setFromDate(e.target.value)}
//                     max={toDate}
//                     className="w-full px-3 py-2 text-sm bg-white/5 border border-blue-500/30 rounded-xl focus:outline-none focus:border-blue-400 text-white date-input md:px-4 md:py-2.5"
//                   />
//                 </div>

//                 <div>
//                   <label className="block mb-2 text-xs font-medium text-blue-200 md:text-sm">
//                     <Calendar className="inline w-3 h-3 mr-1 text-blue-400 md:w-4 md:h-4" />
//                     To Date
//                   </label>
//                   <input
//                     type="date"
//                     value={toDate}
//                     onChange={(e) => setToDate(e.target.value)}
//                     min={fromDate}
//                     max={new Intl.DateTimeFormat('en-CA', {
//                       timeZone: 'Pacific/Kiritimati',
//                       year: 'numeric',
//                       month: '2-digit',
//                       day: '2-digit',
//                     }).format(new Date())}
//                     className="w-full px-3 py-2 text-sm bg-white/5 border border-blue-500/30 rounded-xl focus:outline-none focus:border-blue-400 text-white date-input md:px-4 md:py-2.5"
//                   />
//                 </div>

//                 <div>
//                   <label className="block mb-2 text-xs font-medium text-blue-200 md:text-sm">
//                     <Search className="inline w-3 h-3 mr-1 text-blue-400 md:w-4 md:h-4" />
//                     Search
//                   </label>
//                   <input
//                     type="text"
//                     value={searchTerm}
//                     onChange={(e) => setSearchTerm(e.target.value)}
//                     placeholder="Name or EMP Code"
//                     className="w-full px-3 py-2 text-sm bg-white/5 border border-blue-500/30 rounded-xl focus:outline-none focus:border-blue-400 text-white placeholder-blue-200/50 md:px-4 md:py-2.5"
//                   />
//                 </div>
//               </div>

//               <div className="flex flex-wrap items-center gap-2 mt-4 text-xs md:text-sm">
//                 <span className="text-blue-300">Active Filters:</span>
//                 <span className="px-2 py-1 text-blue-300 border rounded-lg bg-blue-600/20 border-blue-500/30">
//                   {empId === 'All' ? 'All Employees' : `EMP: ${empId}`}
//                 </span>
//                 <span className="px-2 py-1 text-blue-300 border rounded-lg bg-blue-600/20 border-blue-500/30">
//                   {new Date(fromDate).toLocaleDateString()} - {new Date(toDate).toLocaleDateString()}
//                 </span>
//                 {searchTerm && (
//                   <span className="px-2 py-1 text-blue-300 border rounded-lg bg-blue-600/20 border-blue-500/30">
//                     Search: {searchTerm}
//                   </span>
//                 )}
//               </div>
//             </div>
//           )}
//         </div>

//         {/* Table */}
//         <div className="overflow-x-auto border shadow-xl bg-gradient-to-br from-blue-900/40 to-indigo-900/40 backdrop-blur-xl rounded-t-xl border-blue-500/30">
//           <div className="min-w-[800px] md:min-w-0">

//             {/* Table Header */}
//             <div className="px-4 py-3 text-xs font-medium tracking-wider text-blue-300 uppercase border-b bg-white/5 border-blue-500/20">
//               <div className="flex items-center gap-2">
//                 {visibleColumns.serial && <div className="w-[52px]">S.No</div>}

//                 {/* Date column header with sort toggle */}
//                 {visibleColumns.date && (
//                   <div className="w-[80px] flex items-center gap-1">
//                     Date
//                     <button
//                       onClick={(e) => {
//                         e.stopPropagation();
//                         setDateSortOrder((o) => (o === 'desc' ? 'asc' : 'desc'));
//                         setCurrentPage(1);
//                       }}
//                       className="text-blue-400 transition-colors hover:text-blue-200"
//                       title={
//                         dateSortOrder === 'desc'
//                           ? 'Newest first — click for oldest first'
//                           : 'Oldest first — click for newest first'
//                       }
//                     >
//                       {dateSortOrder === 'desc' ? (
//                         <ArrowDown className="w-3 h-3" />
//                       ) : (
//                         <ArrowUp className="w-3 h-3" />
//                       )}
//                     </button>
//                   </div>
//                 )}

//                 {visibleColumns.name && <div className="w-[130px]">Name</div>}
//                 {visibleColumns.empCode && <div className="w-[100px]">EMP Code</div>}
//                 {visibleColumns.worktimezone && <div className="w-[140px]">Work Offset</div>}
//                 {visibleColumns.viewtimezone && <div className="w-[140px]">View Timezone</div>}
//                 {visibleColumns.inTime && <div className="w-[90px]">IN Time</div>}
//                 {visibleColumns.outTime && <div className="w-[90px]">OUT Time</div>}
//                 {visibleColumns.workTime && <div className="w-[75px]">Work Time</div>}
//                 {visibleColumns.earlyIn && <div className="w-[75px]">Early In</div>}
//                 {visibleColumns.lateIn && <div className="w-[75px]">Late In</div>}
//                 {visibleColumns.earlyOut && <div className="w-[75px]">Early Out</div>}
//                 {visibleColumns.lateOut && <div className="w-[75px]">Late Out</div>}
//                 {visibleColumns.overTime && <div className="w-[75px]">Under Time</div>}
//                 {visibleColumns.overTime && <div className="w-[75px]">Over Time</div>}
//                 {visibleColumns.status && <div className="w-[95px]">Status</div>}
//               </div>
//             </div>

//             {/* Table Body */}
//             <div className="divide-y divide-blue-500/10">
//               {loading ? (
//                 <div className="flex items-center justify-center py-12">
//                   <Loader2 className="w-8 h-8 text-blue-400 animate-spin" />
//                 </div>
//               ) : currentItems.length > 0 ? (
//                 currentItems.map((item, index) => {
//                   const inDateTime = parseDateTime(item.IN_Time);
//                   const outDateTime = parseDateTime(item.OUT_Time);
                    
//                   return(
//                   <React.Fragment key={item._id}>
//                     {/* Main Row */}
//                     <div
//                       className="px-4 py-2.5 text-sm transition-colors cursor-pointer hover:bg-white/5"
//                       onClick={() => toggleRowExpand(item._id)}
//                     >
//                       <div className="flex items-center gap-2">
//                         {/* S.No */}
//                         {visibleColumns.serial && (
//                           <div className="w-[52px] flex items-center gap-1 text-xs text-blue-300">
//                             <span className="flex-shrink-0 w-3">
//                               {item.INOUT_Times?.length > 0 &&
//                                 (expandedRows[item._id]
//                                   ? <ChevronUp className="w-3 h-3" />
//                                   : <ChevronDown className="w-3 h-3" />)}
//                             </span>
//                             {indexOfFirstItem + index + 1}
//                           </div>
//                         )}

//                         {/* Date */}
//                         {visibleColumns.date && (
//                           <div className="w-[80px] text-xs text-white whitespace-nowrap">
//                             {/* {new Date(item.DateString).toLocaleDateString('en-GB', {
//                               day: '2-digit', month: '2-digit', year: '2-digit',
//                             })} */}
//                             {/* {parseDateTime(item.DateString).time} */}
//                             <div className="leading-tight">
//                               <div className="text-[9.5px] pb-0.5">{parseDateTime(item.DateString).date}</div>
//                               <div className="text-[9px] text-gray-400">
//                                 {parseDateTime(item.DateString).time}
//                               </div>
//                             </div>
//                           </div>
//                         )}

//                         {/* Name */}
//                         {visibleColumns.name && (
//                           <div className="w-[130px] text-xs font-medium text-white truncate" title={item.Name}>
//                             {item.Name}
//                           </div>
//                         )}

//                         {/* EMP Code */}
//                         {visibleColumns.empCode && (
//                           <div className="w-[100px] text-xs text-blue-300 truncate">{item.EMP_Code}</div>
//                         )}

//                         {/* Work Timezone */}
//                         {visibleColumns.worktimezone && (
//                           <div className="w-[140px] text-xs truncate" title={item.WorkTimeZone}>
//                             {item.WorkTimeZone ? (
//                               <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-blue-500/20 text-gray-400 border border-blue-500/30 truncate max-w-full">
//                                 <span className="truncate">{item.WorkTimeZone}</span>
//                               </span>
//                             ) : (
//                               <span className="text-blue-400/40">—</span>
//                             )}
//                           </div>
//                         )}

//                         {/* View Timezone */}
//                         {visibleColumns.viewtimezone && (
//                           <div className="w-[140px] text-xs truncate" title={item.ViewTimeZone}>
//                             {item.ViewTimeZone ? (
//                               <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-blue-500/20 text-gray-400 border border-blue-500/30 truncate max-w-full">
//                                 <span className="truncate">{item.ViewTimeZone}</span>
//                               </span>
//                             ) : (
//                               <span className="text-blue-400/40">—</span>
//                             )}
//                           </div>
//                         )}

//                         {/* IN Time */}
//                         {visibleColumns.inTime && (
//                           <div className="w-[90px] text-xs text-white whitespace-nowrap">
//                             {/* {item.IN_Time
//                               ? (() => {
//                                   const d = new Date(item.IN_Time);
//                                   return isNaN(d)
//                                     ? item.IN_Time
//                                     : d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' });
//                                 })()
//                               : '—'} */}
//                             {item.IN_Time && item.IN_Time !== '--:--:--' && item.IN_Time !== 'Invalid Date' ? (
//                               <div className="text-[10px] leading-tight">
//                                 <div className="text-[9.5px] pb-0.5">{inDateTime.date}</div>
//                                 <div className="text-[9px] text-gray-400">
//                                   {inDateTime.time}
//                                 </div>
//                               </div>
//                             ) : (
//                               <span className="text-gray-500">00:00:00</span>
//                             )}
//                           </div>
//                         )}

//                         {/* OUT Time */}
//                         {visibleColumns.outTime && (
//                           <div className={`w-[90px] text-xs ${item.INOUT_Times?.length > 2 ? 'text-yellow-300' : 'text-white'} whitespace-nowrap`}>
//                             {/* {item.OUT_Time
//                               ? (() => {
//                                   const d = new Date(item.OUT_Time);
//                                   return isNaN(d)
//                                     ? item.OUT_Time
//                                     : d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' });
//                                 })()
//                               : '—'} */}
//                             {item.OUT_Time && item.OUT_Time !== '--:--:--' && item.OUT_Time !== 'Invalid Date' ? (
//                               <div className="text-[10px] leading-tight">
//                                 <div className="text-[9.5px] pb-0.5">{outDateTime.date}</div>
//                                 <div className={`text-[9px] ${item.INOUT_Times?.length > 2 ? 'text-yellow-300' : 'text-gray-400'}`}>
//                                   {outDateTime.time}
//                                 </div>
//                               </div>
//                             ) : (
//                               <span className="text-gray-500">00:00:00</span>
//                             )}
//                           </div>
//                         )}

//                         {/* Work Time */}
//                         {visibleColumns.workTime && (
//                           <div className={`w-[75px] text-xs ${item.Work_Time > "00:00:00" ? "text-white" : "text-gray-500"}`}>{item.Work_Time || '00:00:00'}</div>
//                         )}

//                         {/* Early In */}
//                         {visibleColumns.earlyIn && (
//                           <div className={`w-[75px] text-xs ${item.Early_In > "00:00:00"  ? "text-green-400" : "text-gray-500"}`}>{item.Early_In || '00:00:00'}</div>
//                         )}

//                         {/* Late In */}
//                         {visibleColumns.lateIn && (
//                           <div className={`w-[75px] text-xs ${item.Late_In > "00:00:00"  ? "text-yellow-400" : "text-gray-500"}`}>{item.Late_In || '00:00:00'}</div>
//                         )}

//                         {/* Early Out */}
//                         {visibleColumns.earlyOut && (
//                           <div className={`w-[75px] text-xs ${item.Erl_Out > "00:00:00" && item.INOUT_Times?.length > 2 && item.INOUT_Times[item.INOUT_Times.length - 1]?.type === 'OUT' ? "text-orange-400" : "text-gray-500"}`}>{item.Erl_Out || '00:00:00'}</div>
//                         )}

//                         {/* Late Out */}
//                         {visibleColumns.lateOut && (
//                           <div className={`w-[75px] text-xs ${item.INOUT_Times?.length > 2 && item.INOUT_Times[item.INOUT_Times.length - 1]?.type === 'OUT' ? "text-orange-400" : "text-gray-500"}`}>{item.Late_Out || '00:00:00'}</div>
//                         )}

//                         {/* Over Time */}
//                         {visibleColumns.underTime && (
//                           <div className={`w-[75px] text-xs ${item.Under_Time > "00:00:00" ? "text-blue-400" : "text-gray-500"}`}>{item.Under_Time || '00:00:00'}</div>
//                         )}

//                         {/* Over Time */}
//                         {visibleColumns.overTime && (
//                           <div className={`w-[75px] text-xs ${item.Over_Time > "00:00:00" ? "text-green-400" : "text-gray-500"}`}>{item.Over_Time || '00:00:00'}</div>
//                         )}

//                         {/* Status */}
//                         {visibleColumns.status && (
//                           <div className="w-[95px]">
//                             {/* {getStatusBadge(item.status, item.Late_In, item.Erl_Out)} */}
//                             {getStatusBadge(item.Late_In, item.Erl_Out, item.INOUT_Times, item.Over_Time)}
//                           </div>
//                         )}
//                       </div>
//                     </div>

//                     {/* Expanded IN/OUT History Row */}
//                     {expandedRows[item._id] && item.INOUT_Times && item.INOUT_Times.length > 0 && (
//                       <div className="px-4 py-3 border-t bg-white/5 border-blue-500/20">
//                         <div className="flex flex-col gap-3 md:flex-row md:items-start md:gap-3">
//                           <History className="w-4 h-4 text-blue-400 md:mt-0.5" />
//                           <div className="flex-1">
//                             <h4 className="mb-2 text-sm font-medium text-blue-300">IN/OUT History</h4>
//                             <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 md:grid-cols-4">
//                               {renderINOUTHistory(item.INOUT_Times)}
//                             </div>
//                             <div className="mt-2 text-xs text-blue-400/70">
//                               Total {item.INOUT_Times.length} entries
//                             </div>
//                             {item.Remark && (
//                               <div className="mt-2 text-xs text-gray-400/70">
//                                 Remark: {item.Remark}
//                               </div>
//                             )}
//                           </div>
//                         </div>
//                       </div>
//                     )}
//                   </React.Fragment>
//                   );
//                 })
//               ) : (
//                 <div className="py-12 text-center">
//                   <FileText className="w-12 h-12 mx-auto mb-3 text-blue-400/30" />
//                   <p className="text-blue-200/50">No attendance records found</p>
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>

//         {/* Pagination Footer */}
//         {filteredAttendance.length > 0 && (
//           <div className="flex flex-col gap-3 px-4 py-3 border border-t-0 bg-white/5 border-blue-500/20 rounded-b-xl md:flex-row md:items-center md:justify-between">
//             <div className="text-xs text-center text-blue-300 md:text-left md:text-sm">
//               Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, filteredAttendance.length)} of{' '}
//               {filteredAttendance.length} entries
//             </div>
//             <div className="flex items-center justify-center gap-2">
//               <button
//                 onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
//                 disabled={currentPage === 1}
//                 className={`p-2 rounded-lg transition-colors ${
//                   currentPage === 1 ? 'text-blue-400/30 cursor-not-allowed' : 'text-blue-400 hover:bg-white/5'
//                 }`}
//               >
//                 <ChevronLeft className="w-4 h-4" />
//               </button>
//               <span className="text-sm text-white">
//                 Page {currentPage} of {totalPages}
//               </span>
//               <button
//                 onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
//                 disabled={currentPage === totalPages}
//                 className={`p-2 rounded-lg transition-colors ${
//                   currentPage === totalPages ? 'text-blue-400/30 cursor-not-allowed' : 'text-blue-400 hover:bg-white/5'
//                 }`}
//               >
//                 <ChevronRight className="w-4 h-4" />
//               </button>
//             </div>
//           </div>
//         )}

//         {/* Summary Card */}
//         <div className="p-3 mt-4 border bg-blue-600/10 border-blue-500/30 rounded-xl md:p-4">
//           <div className="flex items-center gap-2 text-xs md:gap-3 md:text-sm">
//             <AlertCircle className="w-3 h-3 text-blue-400 md:w-4 md:h-4" />
//             <span className="text-blue-300">
//               Showing attendance from{' '}
//               <span className="font-medium text-white">{new Date(fromDate).toLocaleDateString()}</span>
//               {' '}to{' '}
//               <span className="font-medium text-white">{new Date(toDate).toLocaleDateString()}</span>
//               {empId !== 'All' && ` for employee ${empId}`}
//               {' '}— sorted by date{' '}
//               <span className="font-medium text-white">
//                 {dateSortOrder === 'desc' ? '(newest first)' : '(oldest first)'}
//               </span>
//             </span>
//           </div>
//         </div>

//       </div>
//     </div>
//   );
// };

// export default AttendanceManagement;

import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Calendar, Filter, Search, Download, ChevronLeft, ChevronRight,
  Clock, User, CheckCircle, XCircle, AlertCircle,
  Loader2, FileText, RefreshCw, Eye, EyeOff, History, ChevronDown, ChevronUp,
  Users, TrendingDown, ArrowDown, ArrowUp
} from 'lucide-react';
import { Get_Attendance, Get_Attendance_Org } from '../../../services/oprations/Attendance';
import useSocket from '../../../hooks/useSocket';
import StandardSpinner from '../../../utils/Spinner';
import toast from 'react-hot-toast';
import * as XLSX from 'xlsx';
import { useTheme } from '../../../Context/themeContext';

const COLUMN_STORAGE_KEY = 'attendance_visible_columns';

const defaultColumns = {
  serial: true,
  date: true,
  name: true,
  empCode: true,
  worktimezone: true,
  viewtimezone: true,
  inTime: true,
  outTime: true,
  workTime: true,
  earlyIn: false,
  lateIn: true,
  earlyOut: true,
  lateOut: false,
  underTime: false,
  overTime: false,
  status: true,
};

const AttendanceManagement = () => {
  const { theme } = useTheme();
  const isDark = theme === 'dark';
  const dispatch = useDispatch();
  const socket = useSocket();
  const { attendance } = useSelector((state) => state.Attendance);
  const attendances = typeof attendance == 'string' ? JSON.parse(attendance) : attendance;
  console.log('attendance', attendances);
  const { user } = useSelector((state) => state.profile);
  const [loading, setLoading] = useState(false);
  const [filteredAttendance, setFilteredAttendance] = useState([]);

  // ─── Theme-aware classes ──────────────────────────────────────────────
  const bgPrimary = isDark ? 'bg-richblue-950' : 'bg-gray-50';
  const bgCard = isDark ? 'bg-richblue-950' : 'bg-white';
  const bgFilter = isDark ? 'bg-gradient-to-br from-blue-900/40 to-indigo-900/40' : 'bg-gradient-to-br from-blue-50/10 to-gray-50/20';
  const bgTable = isDark ? 'bg-gradient-to-br from-blue-900/40 to-indigo-900/40' : 'bg-gradient-to-br from-blue-50/10 to-gray-50/20';
  const bgInput = isDark ? 'bg-white/5' : 'bg-white/80';
  const bgHover = isDark ? 'hover:bg-white/5' : 'hover:bg-gray-100/50';
  const bgExpanded = isDark ? 'bg-white/5' : 'bg-gray-100/50';
  
  const borderColor = isDark ? 'border-blue-500/30' : 'border-gray-300';
  const borderLight = isDark ? 'border-blue-500/20' : 'border-gray-200';
  const borderInput = isDark ? 'border-blue-500/30' : 'border-gray-300';
  
  const textPrimary = isDark ? 'text-white' : 'text-gray-900';
  const textMuted = isDark ? 'text-blue-200/60' : 'text-gray-500';
  const textPlaceholder = isDark ? 'placeholder-blue-200/50' : 'placeholder-gray-400';
  
  const shadowColor = isDark ? 'shadow-[0_10px_40px_rgba(0,0,0,0.6)]' : 'shadow-[0_10px_40px_rgba(0,0,0,0.1)]';
  const shadowTable = isDark ? 'shadow-xl' : 'shadow-md';

  // Helper function to get first day of month
  const getFirstDayOfMonth = (date) => {
    const year = date.getFullYear();
    const month = date.getMonth();
    return new Date(year, month, 2);
  };

  // Filter states
  const [empId, setEmpId] = useState('All');
  const [fromDate, setFromDate] = useState(() => {
    const today = new Date();
    const firstDay = getFirstDayOfMonth(today);
    return firstDay.toISOString().split('T')[0];
  });
  const [toDate, setToDate] = useState(() => {
    const now = new Date();
    const kiritimatiDate = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'Pacific/Kiritimati',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    }).format(now);
    return kiritimatiDate;
  });

  // UI states
  const [showFilters, setShowFilters] = useState(true);
  const [showExportMenu, setShowExportMenu] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [employeeList, setEmployeeList] = useState([]);
  const [expandedRows, setExpandedRows] = useState({});
  const [expandedInOut, setExpandedInOut] = useState({});
  const [dateSortOrder, setDateSortOrder] = useState('desc');
  const [stats, setStats] = useState({
    total: 0,
    present: 0,
    absent: 0,
    late: 0,
    earlyOut: 0,
  });

  const [showColumnMenu, setShowColumnMenu] = useState(false);

  // ── Persisted column visibility ──────────────────────────────────────────
  const [visibleColumns, setVisibleColumns] = useState(() => {
    try {
      const saved = localStorage.getItem(COLUMN_STORAGE_KEY);
      if (saved) {
        const parsed = JSON.parse(saved);
        const valid = Object.fromEntries(
          Object.keys(defaultColumns)
            .filter(k => k in parsed)
            .map(k => [k, parsed[k]])
        );
        return { ...defaultColumns, ...valid };
      }
    } catch {}
    return { ...defaultColumns };
  });

  const toggleColumn = (column) => {
    setVisibleColumns((prev) => {
      const updated = { ...prev, [column]: !prev[column] };
      try {
        localStorage.setItem(COLUMN_STORAGE_KEY, JSON.stringify(updated));
      } catch {}
      return updated;
    });
  };

   const fetchAttendance = useCallback(async () => {
    setLoading(true);
    try {
      await (user?.role === 'Manager'
        ? dispatch(Get_Attendance(empId, fromDate, toDate))
        : dispatch(Get_Attendance_Org(empId, fromDate, toDate)));
    } catch (error) {
      console.error('Error fetching attendance:', error);
      toast.error('Failed to fetch attendance data');
    } finally {
      setLoading(false);
    }
  },[dispatch, empId, fromDate, toDate, user?.role]);

  useEffect(() => {
    fetchAttendance();
  }, [empId, fromDate, toDate, fetchAttendance]);

  useEffect(() => {
    if (attendance && attendance.length > 0) {
      let filtered = [...attendance].sort((a, b) => {
        const dateA = a.DateString?.split(' ')[0];
        const dateB = b.DateString?.split(' ')[0];
        const dateDiff =
          dateSortOrder === 'desc'
            ? new Date(dateB) - new Date(dateA)
            : new Date(dateA) - new Date(dateB);
        if (dateDiff !== 0) return dateDiff;
        return (a.Name || '').localeCompare(b.Name || '', undefined, { sensitivity: 'base' });
      });

      if (searchTerm) {
        filtered = attendance.filter(
          (item) =>
            item.Name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            item.EMP_Code?.toLowerCase().includes(searchTerm.toLowerCase())
        );
      }

      setFilteredAttendance(filtered);

      const uniqueEmployees = [];
      const seen = new Set();
      attendance.forEach((item) => {
        if (!seen.has(item.EMP_Code)) {
          seen.add(item.EMP_Code);
          uniqueEmployees.push({ id: item.EMP_Code, name: item.Name, empCode: item.EMP_Code });
        }
      });
      setEmployeeList(uniqueEmployees);
      calculateStats(attendance);
    } else {
      setFilteredAttendance([]);
      setEmployeeList([]);
      setStats({ total: 0, present: 0, absent: 0, late: 0, earlyOut: 0 });
    }
  }, [attendance, searchTerm, dateSortOrder]);

  useEffect(() => {
    if (!socket) return;
    socket.on('Attendance_Status', () => {
      fetchAttendance();
    });
    return () => {
      socket.off('Attendance_Status');
    };
  }, [socket, fetchAttendance]);



  const calculateStats = (data) => {
    const stats = {
      total: data.length,
      present: data.filter((item) => item.status === 'P').length,
      absent: data.filter((item) => item.status === 'A' || !item.IN_Time).length,
      late: data.filter((item) => parseFloat(item.Late_In) > 0).length,
      earlyOut: data.filter((item) => parseFloat(item.Erl_Out) > 0).length,
    };
    setStats(stats);
  };

  const handleRefresh = () => {
    fetchAttendance();
  };

  const prepareExportData = () => {
    const headers = [
      'Date', 'Name', 'ID', 'Status', 'Work Offset', 'View TimeZone',
      'First IN Time', 'Last OUT Time', 'Work Time', 'Early In',
      'Late In', 'Early Out', 'Late Out', 'Under Time', 'Over Time', 'IN/OUT Times',
    ];

    const rows = filteredAttendance.map((item) => {
      const inoutStr = item.INOUT_Times?.length
        ? item.INOUT_Times.map((r) => `${r.type}: ${r.time}`).join(' ; ')
        : '';
      return [
        item.DateString || '',
        item.Name || '',
        item.EMP_Code || '',
        item.status === 'P' ? 'Present' : 'Absent',
        item.WorkTimeZone || '',
        item.ViewTimeZone || '',
        item.IN_Time || '--:--:--',
        item.OUT_Time || '--:--:--',
        item.Work_Time || '00:00:00',
        item.Erly_In || '00:00:00',
        item.Late_In || '00:00:00',
        item.Erl_Out || '00:00:00',
        item.Late_Out || '00:00:00',
        item.Under_Time || '00:00:00',
        item.Over_Time || '00:00:00',
        inoutStr,
      ];
    });

    return { headers, rows };
  };

  const handleExportCSV = () => {
    const { headers, rows } = prepareExportData();
    const escape = (val) => `"${String(val).replace(/"/g, '""')}"`;
    const csv = [headers, ...rows].map((row) => row.map(escape).join(',')).join('\n');
    const blob = new Blob([csv], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `attendance_${fromDate}_to_${toDate}.csv`;
    a.click();
    window.URL.revokeObjectURL(url);
    setShowExportMenu(false);
    toast.success('Exported as CSV successfully');
  };

  const handleExportExcel = () => {
    const { headers, rows } = prepareExportData();
    const worksheetData = [headers, ...rows];
    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
    worksheet['!cols'] = [
      { wch: 15 }, { wch: 25 }, { wch: 15 }, { wch: 27 }, { wch: 22 },
      { wch: 22 }, { wch: 12 }, { wch: 12 }, { wch: 12 }, { wch: 12 },
      { wch: 12 }, { wch: 80 }, { wch: 10 },
    ];
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Attendance');
    XLSX.writeFile(workbook, `attendance_${fromDate}_to_${toDate}.xlsx`);
    setShowExportMenu(false);
    toast.success('Exported as Excel successfully');
  };

  const toggleRowExpand = (id) => {
    setExpandedRows((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const toggleShowAll = (id) => {
    setExpandedInOut((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const parseDateTime = (dateTimeStr) => {
    if (!dateTimeStr || dateTimeStr === '--' || dateTimeStr === 'Invalid Date') {
      return { date: '—', time: '—' };
    }
    
    try {
      if (typeof dateTimeStr === 'string' && dateTimeStr.includes(' ')) {
        const parts = dateTimeStr.split(' ');
        if (parts.length >= 3) {
          const datePart = parts[0];
          const timePart = `${parts[1]} ${parts[2]}`;
          
          const dateObj = new Date(datePart);
          if (!isNaN(dateObj.getTime())) {
            const day = String(dateObj.getDate()).padStart(2, '0');
            const month = String(dateObj.getMonth() + 1).padStart(2, '0');
            const year = dateObj.getFullYear();
            const formattedDate = `${day}/${month}/${year}`;
            
            const timeParts = timePart.split(' ');
            if (timeParts.length === 2) {
              const [hourMinSec, ampm] = timeParts;
              const [hours, minutes, seconds] = hourMinSec.split(':');
              const hour = parseInt(hours);
              const hourStr = String(hour).padStart(2, '0');
              return {
                date: formattedDate,
                time: `${hourStr}:${minutes}:${seconds} ${ampm}`
              };
            }
          }
        }
      }
      
      const date = new Date(dateTimeStr);
      if (!isNaN(date.getTime())) {
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return {
          date: `${day}/${month}/${year}`,
          time: date.toLocaleTimeString('en-US', { 
            hour: '2-digit', 
            minute: '2-digit',
            second: '2-digit',
            hour12: true 
          })
        };
      }
      
      return { date: '—', time: '—' };
    } catch {
      return { date: '—', time: '—' };
    }
  };

  const getStatusBadge = (lateIn, earlyOut, inOutTimes = [], overTime, underTime) => {
    if (!inOutTimes.length) {
      return (
        <span className="px-2 py-1 text-xs font-medium text-red-600 rounded-full dark:text-red-400 dark:bg-red-500/20 bg-red-400/20 whitespace-nowrap">
          Absent
        </span>
      );
    }

    if(overTime && overTime !== '00:00:00') {
      return (
        <span className="px-2 py-1 text-xs font-medium text-blue-600 rounded-full dark:text-blue-400 dark:bg-blue-500/20 bg-blue-400/20 whitespace-nowrap">
          Over Time
        </span>
      );
    }

    if(underTime && underTime !== '00:00:00') {
      return (
        <span className="px-2 py-1 text-xs font-medium text-red-600 rounded-full dark:text-red-400 bg-red-500/20 whitespace-nowrap">
          Under Time
        </span>
      );
    }

    const lateTotalSeconds = lateIn
      .split(":")
      .map(Number)
      .reduce((total, value, index) => {
        return total + value * [3600, 60, 1][index];
      }, 0);

    const earlyOutTotalSeconds = earlyOut
      .split(":")
      .map(Number)
      .reduce((total, value, index) => {
        return total + value * [3600, 60, 1][index];
      }, 0);

    const lastPunchType = inOutTimes[inOutTimes.length - 1]?.type?.toUpperCase();

    if (lastPunchType === "IN") {
      if (lateTotalSeconds > 0) {
        return (
          <span className="px-2 py-1 text-xs font-medium text-yellow-400 rounded-full bg-yellow-500/20 whitespace-nowrap">
            Late
          </span>
        );
      }
      return (
        <span className="px-2 py-1 text-xs font-medium text-green-400 rounded-full bg-green-500/20 whitespace-nowrap">
          Present
        </span>
      );
    }

    if (lastPunchType === "OUT") {
      if (lateTotalSeconds > 0 && earlyOutTotalSeconds === 0) {
        return (
          <span className="px-2 py-1 text-xs font-medium text-yellow-500 rounded-full dark:text-yellow-400 bg-yellow-400/20 dark:bg-yellow-500/20 whitespace-nowrap">
            Late
          </span>
        );
      }
      else if (lateTotalSeconds === 0 && earlyOutTotalSeconds > 0) {
        return (
          <span className="px-2 py-1 text-xs font-medium text-orange-700 rounded-full dark:text-orange-400 dark:bg-orange-500/20 bg-orange-400/30 whitespace-nowrap">
            Early Out
          </span>
        );
      }
      else if (lateTotalSeconds > 0 && earlyOutTotalSeconds > 0) {
        return (
          <span className="px-2 py-1 text-xs font-medium text-orange-500 rounded-full dark:text-orange-200 bg-orange-300/40 dark:bg-orange-300/20 whitespace-nowrap">
            Late / Early 
          </span>
        );
      }
      return (
        <span className="px-2 py-1 text-xs font-medium text-green-600 rounded-full dark:text-green-400 bg-green-300/20 dark:bg-green-500/20 whitespace-nowrap">
          Present
        </span>
      );
    }

    return (
      <span className="px-2 py-1 text-xs font-medium text-green-400 rounded-full bg-green-500/20 whitespace-nowrap">
        Present
      </span>
    );
  };

  const renderINOUTHistory = (inoutTimes) => {
    if (!inoutTimes || inoutTimes.length === 0) {
      return <div className={`text-xs ${isDark ? 'text-blue-300/50' : 'text-gray-400'}`}>No IN/OUT records</div>;
    }

    const showAll = expandedInOut[inoutTimes[0]?._id] || false;
    const displayedEntries = showAll ? inoutTimes : inoutTimes.slice(0, 4);
    const hasMore = inoutTimes.length > 4;

    return (
      <div className="space-y-1">
        {displayedEntries.map((record, idx) => {
          const time = record?.time;
          const isIN = record.type === 'IN';
          return (
            <div key={idx} className="flex items-center gap-2 text-xs">
              <div
                className={`w-5 h-5 px-3.5 py-1 rounded-full flex items-center justify-center text-[10px] font-medium ${
                  isIN ? 'bg-green-500/20 text-green-400' : 'bg-red-500/20 text-red-400'
                }`}
              >
                {isIN ? 'IN' : 'OUT'}
              </div>
              <span className={`text-xs ${textPrimary}`}>{time}</span>
            </div>
          );
        })}

        {hasMore && (
          <button
            onClick={() => toggleShowAll(inoutTimes[0]?._id)}
            className={`flex items-center gap-1 mt-1 text-xs ${isDark ? 'text-blue-400 hover:text-blue-300' : 'text-blue-600 hover:text-blue-800'}`}
          >
            {showAll ? (
              <>Show Less <ChevronUp className="w-3 h-3" /></>
            ) : (
              <>+{inoutTimes.length - 4} more <ChevronDown className="w-3 h-3" /></>
            )}
          </button>
        )}
      </div>
    );
  };

  // Pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredAttendance.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredAttendance.length / itemsPerPage);

  if (loading && !attendance) {
    return <StandardSpinner />;
  }
   
  const hiddenCount = Object.keys(defaultColumns).filter(key => !visibleColumns[key]).length;

  return (
    <div className={`min-h-screen p-3 pt-0 ${bgPrimary} md:p-4 lg:p-6 transition-colors duration-300`}>
      <div className="mx-auto max-w-7xl">

        {/* Header */}
        <div className="flex flex-col gap-4 mb-6 md:flex-row md:items-center md:justify-between">
          <div>
            <h1 className="text-2xl font-bold text-transparent bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text md:text-3xl">
              Attendance Management
            </h1>
            <p className={`mt-1 text-xs ${textMuted} md:text-sm`}>
              View and manage employee attendance records with multiple IN/OUT tracking
            </p>
          </div>

          <div className="flex items-center gap-2">
            {/* Refresh */}
            <button
              onClick={handleRefresh}
              className={`p-2.5 ${isDark ? 'bg-white/5 hover:bg-white/10 border-blue-500/30 text-blue-400 hover:text-blue-300' : 'bg-gray-100 hover:bg-gray-200 border-gray-300 text-gray-600 hover:text-gray-800'} border rounded-xl transition-colors`}
              title="Refresh"
            >
              <RefreshCw className={`w-4 h-4 ${loading ? 'animate-spin' : ''}`} />
            </button>

            {/* Column Selector */}
            <div className="relative">
              <button
                onClick={() => setShowColumnMenu((prev) => !prev)}
                className={`px-3 py-2.5 ${isDark ? 'bg-white/5 hover:bg-white/10 border-blue-500/30 text-blue-300' : 'bg-gray-100 hover:bg-gray-200 border-gray-300 text-gray-700'} border rounded-xl flex items-center gap-2 text-sm transition-colors`}
              >
                Columns
                {hiddenCount > 0 && (
                  <span className="inline-flex items-center justify-center w-4 h-4 text-[10px] font-bold text-white bg-blue-500 rounded-full leading-none">
                    {hiddenCount}
                  </span>
                )}
                <ChevronDown className={`w-4 h-4 transition-transform ${showColumnMenu ? 'rotate-180' : ''}`} />
              </button>

              {showColumnMenu && (
                <>
                  <div className="fixed inset-0 z-10" onClick={() => setShowColumnMenu(false)} />
                  <div className={`absolute -right-16 z-20 w-56 p-3 mt-2 border rounded-xl ${isDark ? 'bg-[#0a0f2e] border-blue-500/30' : 'bg-white border-gray-300 shadow-lg'} shadow-xl`}>
                    <div className="space-y-2">
                      {Object.entries({
                        serial: 'S.No',
                        date: 'Date',
                        name: 'Name',
                        empCode: 'EMP Code',
                        worktimezone: 'Work TimeZone',
                        viewtimezone: 'View Timezone',
                        inTime: 'IN Time',
                        outTime: 'OUT Time',
                        workTime: 'Work Time',
                        earlyIn: 'Early In',
                        lateIn: 'Late In',
                        earlyOut: 'Early Out',
                        lateOut: 'Late Out',
                        underTime: 'Under Time',
                        overTime: 'Over Time',
                        status: 'Status',
                      }).map(([key, label]) => (
                        <label key={key} className={`flex items-center gap-2 text-sm ${isDark ? 'text-blue-200' : 'text-gray-700'} cursor-pointer`}>
                          <input
                            type="checkbox"
                            checked={visibleColumns[key]}
                            onChange={() => toggleColumn(key)}
                          />
                          {label}
                        </label>
                      ))}
                    </div>
                  </div>
                </>
              )}
            </div>

            {/* Export Dropdown */}
            <div className="relative">
              <button
                onClick={() => setShowExportMenu((prev) => !prev)}
                disabled={filteredAttendance.length === 0}
                className="px-3 py-2.5 md:px-4 bg-gradient-to-r from-blue-600 to-cyan-600 hover:from-blue-500 hover:to-cyan-500 text-white font-medium rounded-xl flex items-center gap-2 shadow-lg disabled:opacity-50 disabled:cursor-not-allowed transition-all text-sm md:text-base"
              >
                <Download className="w-4 h-4" />
                <span className="hidden sm:inline">Export</span>
                <ChevronDown className={`w-4 h-4 transition-transform ${showExportMenu ? 'rotate-180' : ''}`} />
              </button>

              {showExportMenu && (
                <>
                  <div className="fixed inset-0 z-10" onClick={() => setShowExportMenu(false)} />
                  <div className={`absolute right-0 mt-2 w-44 z-20 ${isDark ? 'bg-[#0a0f2e] border-blue-500/30' : 'bg-white border-gray-300'} border rounded-xl shadow-2xl overflow-hidden`}>
                    <button
                      onClick={handleExportCSV}
                      className={`flex items-center w-full gap-3 px-4 py-3 text-sm ${isDark ? 'text-blue-200 hover:bg-white/10' : 'text-gray-700 hover:bg-gray-100'} transition-colors`}
                    >
                      <FileText className="w-4 h-4 text-blue-400 shrink-0" />
                      Export as CSV
                    </button>
                    <div className={`h-px ${isDark ? 'bg-blue-500/20' : 'bg-gray-200'}`} />
                    <button
                      onClick={handleExportExcel}
                      className={`flex items-center w-full gap-3 px-4 py-3 text-sm ${isDark ? 'text-blue-200 hover:bg-white/10' : 'text-gray-700 hover:bg-gray-100'} transition-colors`}
                    >
                      <FileText className="w-4 h-4 text-green-400 shrink-0" />
                      Export as Excel
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>

        {/* Stats Cards */}
        <div className="grid grid-cols-2 gap-3 mb-6 md:grid-cols-5 md:gap-4">
          <div className={`${bgCard} border ${isDark ? 'border-blue-700/80' : 'border-gray-300'} rounded-xl p-3 md:p-4 ${shadowColor} transition-colors duration-300`}>
            <div className="flex items-center justify-between">
              <p className={`text-xs ${isDark ? 'text-blue-300' : 'text-gray-600'} md:text-sm`}>Total Records</p>
              <Users className={`w-4 h-4 ${isDark ? 'text-blue-400' : 'text-blue-600'}`} />
            </div>
            <p className={`text-xl font-bold ${textPrimary} md:text-2xl`}>{stats.total}</p>
          </div>
          <div className={`${bgCard} rounded-xl p-3 md:p-4 ${shadowColor} border ${isDark ? 'border-green-700/40' : 'border-green-300'} transition-colors duration-300`}>
            <div className="flex items-center justify-between">
              <p className={`text-xs ${isDark ? 'text-green-300' : 'text-green-600'} md:text-sm`}>Present</p>
              <CheckCircle className={`w-4 h-4 ${isDark ? 'text-green-400' : 'text-green-600'}`} />
            </div>
            <p className={`text-xl font-bold ${textPrimary} md:text-2xl`}>{stats.present}</p>
          </div>
          <div className={`${bgCard} rounded-xl p-3 md:p-4 ${shadowColor} border ${isDark ? 'border-red-700/40' : 'border-red-300'} transition-colors duration-300`}>
            <div className="flex items-center justify-between">
              <p className={`text-xs ${isDark ? 'text-red-300' : 'text-red-600'} md:text-sm`}>Absent</p>
              <XCircle className={`w-4 h-4 ${isDark ? 'text-red-400' : 'text-red-600'}`} />
            </div>
            <p className={`text-xl font-bold ${textPrimary} md:text-2xl`}>{stats.absent}</p>
          </div>
          <div className={`${bgCard} rounded-xl p-3 md:p-4 ${shadowColor} border ${isDark ? 'border-yellow-700/60' : 'border-yellow-100'} transition-colors duration-300`}>
            <div className="flex items-center justify-between">
              <p className={`text-xs ${isDark ? 'text-yellow-300' : 'text-yellow-600'} md:text-sm`}>Late Arrivals</p>
              <Clock className={`w-4 h-4 ${isDark ? 'text-yellow-400' : 'text-yellow-600'}`} />
            </div>
            <p className={`text-xl font-bold ${textPrimary} md:text-2xl`}>{stats.late}</p>
          </div>
          <div className={`col-span-2 md:col-span-1 ${bgCard} rounded-xl p-3 md:p-4 ${shadowColor} border ${isDark ? 'border-orange-500/30' : 'border-orange-300'} transition-colors duration-300`}>
            <div className="flex items-center justify-between">
              <p className={`text-xs ${isDark ? 'text-orange-300' : 'text-orange-600'} md:text-sm`}>Early Out</p>
              <TrendingDown className={`w-4 h-4 ${isDark ? 'text-orange-400' : 'text-orange-600'}`} />
            </div>
            <p className={`text-xl font-bold ${textPrimary} md:text-2xl`}>{stats.earlyOut}</p>
          </div>
        </div>

        {/* Filters Section */}
        <div className={`mb-6 overflow-hidden border ${shadowTable} ${bgFilter} backdrop-blur-xl rounded-xl ${borderColor} transition-colors duration-300`}>
          <div
            className={`flex items-center justify-between px-4 py-3 border-b cursor-pointer md:px-6 ${borderLight}`}
            onClick={() => setShowFilters(!showFilters)}
          >
            <div className="flex items-center gap-2">
              <Filter className={`w-4 h-4 ${isDark ? 'text-blue-400' : 'text-blue-600'}`} />
              <span className={`text-sm font-medium ${textPrimary} md:text-base`}>Filters</span>
            </div>
            <button className={isDark ? 'text-blue-400 hover:text-blue-300' : 'text-gray-600 hover:text-gray-800'}>
              {showFilters ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
            </button>
          </div>

          {showFilters && (
            <div className="p-4 md:p-6">
              <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
                <div>
                  <label className={`block mb-2 text-xs font-medium ${isDark ? 'text-blue-200' : 'text-gray-700'} md:text-sm`}>
                    <User className={`inline w-3 h-3 mr-1 ${isDark ? 'text-blue-400' : 'text-blue-600'} md:w-4 md:h-4`} />
                    Employee
                  </label>
                  <select
                    value={empId}
                    onChange={(e) => setEmpId(e.target.value)}
                    className={`w-full px-3 py-2 text-sm ${bgInput} border ${borderInput} rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 ${textPrimary} md:px-4 md:py-2.5 transition-colors duration-300`}
                  >
                    <option value="All" className={isDark ? 'bg-[#0a0f1e]' : 'bg-white'}>All Employees</option>
                    {employeeList.map((emp) => (
                      <option key={emp.id} value={emp.id} className={isDark ? 'bg-[#0a0f1e]' : 'bg-white'}>
                        {emp.name} ({emp.empCode})
                      </option>
                    ))}
                  </select>
                </div>

                <div>
                  <label className={`block mb-2 text-xs font-medium ${isDark ? 'text-blue-200' : 'text-gray-700'} md:text-sm`}>
                    <Calendar className={`inline w-3 h-3 mr-1 ${isDark ? 'text-blue-400' : 'text-blue-600'} md:w-4 md:h-4`} />
                    From Date
                  </label>
                  <input
                    type="date"
                    value={fromDate}
                    onChange={(e) => setFromDate(e.target.value)}
                    max={toDate}
                    className={`w-full px-3 py-2 text-sm ${bgInput} border ${borderInput} rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 ${textPrimary} date-input md:px-4 md:py-2.5 transition-colors duration-300`}
                  />
                </div>

                <div>
                  <label className={`block mb-2 text-xs font-medium ${isDark ? 'text-blue-200' : 'text-gray-700'} md:text-sm`}>
                    <Calendar className={`inline w-3 h-3 mr-1 ${isDark ? 'text-blue-400' : 'text-blue-600'} md:w-4 md:h-4`} />
                    To Date
                  </label>
                  <input
                    type="date"
                    value={toDate}
                    onChange={(e) => setToDate(e.target.value)}
                    min={fromDate}
                    max={new Intl.DateTimeFormat('en-CA', {
                      timeZone: 'Pacific/Kiritimati',
                      year: 'numeric',
                      month: '2-digit',
                      day: '2-digit',
                    }).format(new Date())}
                    className={`w-full px-3 py-2 text-sm ${bgInput} border ${borderInput} rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 ${textPrimary} date-input md:px-4 md:py-2.5 transition-colors duration-300`}
                  />
                </div>

                <div>
                  <label className={`block mb-2 text-xs font-medium ${isDark ? 'text-blue-200' : 'text-gray-700'} md:text-sm`}>
                    <Search className={`inline w-3 h-3 mr-1 ${isDark ? 'text-blue-400' : 'text-blue-600'} md:w-4 md:h-4`} />
                    Search
                  </label>
                  <input
                    type="text"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    placeholder="Name or EMP Code"
                    className={`w-full px-3 py-2 text-sm ${bgInput} border ${borderInput} rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 ${textPrimary} ${textPlaceholder} md:px-4 md:py-2.5 transition-colors duration-300`}
                  />
                </div>
              </div>

              <div className="flex flex-wrap items-center gap-2 mt-4 text-xs md:text-sm">
                <span className={isDark ? 'text-blue-300' : 'text-gray-600'}>Active Filters:</span>
                <span className={`px-2 py-1 ${isDark ? 'text-blue-300 border-blue-500/30 bg-blue-600/20' : 'text-gray-700 border-gray-300 bg-gray-200/50'} border rounded-lg`}>
                  {empId === 'All' ? 'All Employees' : `EMP: ${empId}`}
                </span>
                <span className={`px-2 py-1 ${isDark ? 'text-blue-300 border-blue-500/30 bg-blue-600/20' : 'text-gray-700 border-gray-300 bg-gray-200/50'} border rounded-lg`}>
                  {new Date(fromDate).toLocaleDateString()} - {new Date(toDate).toLocaleDateString()}
                </span>
                {searchTerm && (
                  <span className={`px-2 py-1 ${isDark ? 'text-blue-300 border-blue-500/30 bg-blue-600/20' : 'text-gray-700 border-gray-300 bg-gray-200/50'} border rounded-lg`}>
                    Search: {searchTerm}
                  </span>
                )}
              </div>
            </div>
          )}
        </div>

        {/* Table */}
        <div className={`overflow-x-auto border ${shadowTable} ${bgTable} backdrop-blur-xl rounded-t-xl ${borderColor} transition-colors duration-300`}>
          <div className="min-w-[800px] md:min-w-0">

            {/* Table Header */}
            <div className={`px-4 py-3 text-xs font-medium tracking-wider ${isDark ? 'text-blue-300 border-blue-500/20 bg-white/5' : 'text-gray-600 border-gray-200 bg-gray-50/50'} uppercase border-b`}>
              <div className="flex items-center gap-2">
                {visibleColumns.serial && <div className="w-[52px]">S.No</div>}
                {visibleColumns.date && (
                  <div className="w-[80px] flex items-center gap-1">
                    Date
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        setDateSortOrder((o) => (o === 'desc' ? 'asc' : 'desc'));
                        setCurrentPage(1);
                      }}
                      className={isDark ? 'text-blue-400 transition-colors hover:text-blue-200' : 'text-gray-500 transition-colors hover:text-gray-700'}
                      title={
                        dateSortOrder === 'desc'
                          ? 'Newest first — click for oldest first'
                          : 'Oldest first — click for newest first'
                      }
                    >
                      {dateSortOrder === 'desc' ? (
                        <ArrowDown className="w-3 h-3" />
                      ) : (
                        <ArrowUp className="w-3 h-3" />
                      )}
                    </button>
                  </div>
                )}
                {visibleColumns.name && <div className="w-[130px]">Name</div>}
                {visibleColumns.empCode && <div className="w-[100px]">EMP Code</div>}
                {visibleColumns.worktimezone && <div className="w-[140px]">Work Offset</div>}
                {visibleColumns.viewtimezone && <div className="w-[140px]">View Timezone</div>}
                {visibleColumns.inTime && <div className="w-[90px]">First In</div>}
                {visibleColumns.outTime && <div className="w-[90px]">Last OUT</div>}
                {visibleColumns.workTime && <div className="w-[75px]">Work Time</div>}
                {visibleColumns.earlyIn && <div className="w-[75px]">Early In</div>}
                {visibleColumns.lateIn && <div className="w-[75px]">Late In</div>}
                {visibleColumns.earlyOut && <div className="w-[75px]">Early Out</div>}
                {visibleColumns.lateOut && <div className="w-[75px]">Late Out</div>}
                {visibleColumns.underTime && <div className="w-[75px]">Under Time</div>}
                {visibleColumns.overTime && <div className="w-[75px]">Over Time</div>}
                {visibleColumns.status && <div className="w-[95px]">Status</div>}
              </div>
            </div>

            {/* Table Body */}
            <div className={`divide-y ${isDark ? 'divide-blue-500/10' : 'divide-gray-200'}`}>
              {loading ? (
                <div className="flex items-center justify-center py-12">
                  <Loader2 className={`w-8 h-8 ${isDark ? 'text-blue-400' : 'text-blue-600'} animate-spin`} />
                </div>
              ) : currentItems.length > 0 ? (
                currentItems.map((item, index) => {
                  const inDateTime = parseDateTime(item.IN_Time);
                  const outDateTime = parseDateTime(item.OUT_Time);
                    
                  return(
                  <React.Fragment key={item._id}>
                    {/* Main Row */}
                    <div
                      className={`px-4 py-2.5 text-sm transition-colors cursor-pointer ${bgHover}`}
                      onClick={() => toggleRowExpand(item._id)}
                    >
                      <div className="flex items-center gap-2">
                        {/* S.No */}
                        {visibleColumns.serial && (
                          <div className={`w-[52px] flex items-center gap-1 text-xs ${isDark ? 'text-blue-300' : 'text-gray-500'}`}>
                            <span className="flex-shrink-0 w-3">
                              {item.INOUT_Times?.length > 0 &&
                                (expandedRows[item._id]
                                  ? <ChevronUp className="w-3 h-3" />
                                  : <ChevronDown className="w-3 h-3" />)}
                            </span>
                            {indexOfFirstItem + index + 1}
                          </div>
                        )}

                        {/* Date */}
                        {visibleColumns.date && (
                          <div className="w-[80px] text-xs text-white whitespace-nowrap">
                            <div className="leading-tight">
                              <div className={`text-[9.5px] pb-0.5 ${textPrimary}`}>{parseDateTime(item.DateString).date}</div>
                              <div className={`text-[9px] ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>
                                {parseDateTime(item.DateString).time}
                              </div>
                            </div>
                          </div>
                        )}

                        {/* Name */}
                        {visibleColumns.name && (
                          <div className={`w-[130px] text-xs font-medium ${textPrimary} truncate`} title={item.Name}>
                            {item.Name}
                          </div>
                        )}

                        {/* EMP Code */}
                        {visibleColumns.empCode && (
                          <div className={`w-[100px] text-xs ${isDark ? 'text-blue-300' : 'text-blue-600'} truncate`}>{item.EMP_Code}</div>
                        )}

                        {/* Work Timezone */}
                        {visibleColumns.worktimezone && (
                          <div className="w-[140px] text-xs truncate" title={item.WorkTimeZone}>
                            {item.WorkTimeZone ? (
                              <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full ${isDark ? 'bg-blue-500/20 text-gray-400 border-blue-500/30' : 'bg-blue-100/10 text-gray-600 border-blue-300'} border truncate max-w-full`}>
                                <span className="truncate">{item.WorkTimeZone}</span>
                              </span>
                            ) : (
                              <span className={isDark ? 'text-blue-400/40' : 'text-gray-400'}>—</span>
                            )}
                          </div>
                        )}

                        {/* View Timezone */}
                        {visibleColumns.viewtimezone && (
                          <div className="w-[140px] text-xs truncate" title={item.ViewTimeZone}>
                            {item.ViewTimeZone ? (
                              <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full ${isDark ? 'bg-blue-500/20 text-gray-400 border-blue-500/30' : 'bg-blue-100/10 text-gray-600 border-blue-300'} border truncate max-w-full`}>
                                <span className="truncate">{item.ViewTimeZone}</span>
                              </span>
                            ) : (
                              <span className={isDark ? 'text-blue-400/40' : 'text-gray-400'}>—</span>
                            )}
                          </div>
                        )}

                        {/* IN Time */}
                        {visibleColumns.inTime && (
                          <div className="w-[90px] text-xs text-white whitespace-nowrap">
                            {item.IN_Time && item.IN_Time !== '--:--:--' && item.IN_Time !== 'Invalid Date' ? (
                              <div className="text-[10px] leading-tight">
                                <div className={`text-[9.5px] pb-0.5 ${textPrimary}`}>{inDateTime.date}</div>
                                <div className={`text-[9px] ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>
                                  {inDateTime.time}
                                </div>
                              </div>
                            ) : (
                              <span className={isDark ? 'text-gray-500' : 'text-gray-400'}>00:00:00</span>
                            )}
                          </div>
                        )}

                        {/* OUT Time */}
                        {visibleColumns.outTime && (
                          <div className={`w-[90px] text-xs ${item.INOUT_Times?.length > 2 ? 'text-yellow-400' : textPrimary} whitespace-nowrap`}>
                            {item.OUT_Time && item.OUT_Time !== '--:--:--' && item.OUT_Time !== 'Invalid Date' ? (
                              <div className="text-[10px] leading-tight">
                                <div className={`text-[9.5px] pb-0.5 ${item.INOUT_Times?.length > 2 ? 'text-yellow-400' : textPrimary}`}>{outDateTime.date}</div>
                                <div className={`text-[9px] ${item.INOUT_Times?.length > 2 ? 'text-yellow-400' : isDark ? 'text-gray-400' : 'text-gray-500'}`}>
                                  {outDateTime.time}
                                </div>
                              </div>
                            ) : (
                              <span className={isDark ? 'text-gray-500' : 'text-gray-400'}>00:00:00</span>
                            )}
                          </div>
                        )}

                        {/* Work Time */}
                        {visibleColumns.workTime && (
                          <div className={`w-[75px] text-xs ${item.Work_Time > "00:00:00" ? textPrimary : isDark ? 'text-gray-500' : 'text-gray-400'}`}>{item.Work_Time || '00:00:00'}</div>
                        )}

                        {/* Early In */}
                        {visibleColumns.earlyIn && (
                          <div className={`w-[75px] text-xs ${item.Erly_In > "00:00:00" ? "text-green-600" : isDark ? 'text-gray-500' : 'text-gray-400'}`}>{item.Erly_In || '00:00:00'}</div>
                        )}

                        {/* Late In */}
                        {visibleColumns.lateIn && (
                          <div className={`w-[75px] text-xs ${item.Late_In > "00:00:00" ? "text-yellow-400" : isDark ? 'text-gray-500' : 'text-gray-400'}`}>{item.Late_In || '00:00:00'}</div>
                        )}

                        {/* Early Out */}
                        {visibleColumns.earlyOut && (
                          <div className={`w-[75px] text-xs ${item.Erl_Out > "00:00:00" && item.INOUT_Times?.length > 2 && item.INOUT_Times[item.INOUT_Times.length - 1]?.type === 'OUT' ? "text-orange-400" : isDark ? 'text-gray-500' : 'text-gray-400'}`}>{item.Erl_Out || '00:00:00'}</div>
                        )}

                        {/* Late Out */}
                        {visibleColumns.lateOut && (
                          <div className={`w-[75px] text-xs ${item.INOUT_Times?.length > 2 && item.INOUT_Times[item.INOUT_Times.length - 1]?.type === 'OUT' ? "text-orange-400" : isDark ? 'text-gray-500' : 'text-gray-400'}`}>{item.Late_Out || '00:00:00'}</div>
                        )}

                        {/* Under Time */}
                        {visibleColumns.underTime && (
                          <div className={`w-[75px] text-xs ${item.Under_Time > "00:00:00" ? "text-blue-400" : isDark ? 'text-gray-500' : 'text-gray-400'}`}>{item.Under_Time || '00:00:00'}</div>
                        )}

                        {/* Over Time */}
                        {visibleColumns.overTime && (
                          <div className={`w-[75px] text-xs ${item.Over_Time > "00:00:00" ? "text-green-400" : isDark ? 'text-gray-500' : 'text-gray-400'}`}>{item.Over_Time || '00:00:00'}</div>
                        )}

                        {/* Status */}
                        {visibleColumns.status && (
                          <div className="w-[95px]">
                            {getStatusBadge(item.Late_In, item.Erl_Out, item.INOUT_Times, item.Over_Time, item.Under_Time)}
                          </div>
                        )}
                      </div>
                    </div>

                    {/* Expanded IN/OUT History Row */}
                    {expandedRows[item._id] && item.INOUT_Times && item.INOUT_Times.length > 0 && (
                      <div className={`px-4 py-3 border-t ${bgExpanded} ${borderLight}`}>
                        <div className="flex flex-col gap-3 md:flex-row md:items-start md:gap-3">
                          <History className={`w-4 h-4 ${isDark ? 'text-blue-400' : 'text-blue-600'} md:mt-0.5`} />
                          <div className="flex-1">
                            <h4 className={`mb-2 text-sm font-medium ${isDark ? 'text-blue-300' : 'text-blue-700'}`}>IN/OUT History</h4>
                            <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 md:grid-cols-4">
                              {renderINOUTHistory(item.INOUT_Times)}
                            </div>
                            <div className={`mt-2 text-xs ${isDark ? 'text-blue-400/70' : 'text-gray-500'}`}>
                              Total {item.INOUT_Times.length} entries
                            </div>
                            {item.Remark && (
                              <div className={`mt-2 text-xs ${isDark ? 'text-gray-400/70' : 'text-gray-500'}`}>
                                Remark: {item.Remark}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                  </React.Fragment>
                  );
                })
              ) : (
                <div className="py-12 text-center">
                  <FileText className={`w-12 h-12 mx-auto mb-3 ${isDark ? 'text-blue-400/30' : 'text-gray-400'}`} />
                  <p className={isDark ? 'text-blue-200/50' : 'text-gray-500'}>No attendance records found</p>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Pagination Footer */}
        {filteredAttendance.length > 0 && (
          <div className={`flex flex-col gap-3 px-4 py-3 border border-t-0 ${isDark ? 'bg-white/5 border-blue-500/20' : 'bg-gray-50/50 border-gray-200'} rounded-b-xl md:flex-row md:items-center md:justify-between transition-colors duration-300`}>
            <div className={`text-xs text-center ${isDark ? 'text-blue-300' : 'text-gray-600'} md:text-left md:text-sm`}>
              Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, filteredAttendance.length)} of{' '}
              {filteredAttendance.length} entries
            </div>
            <div className="flex items-center justify-center gap-2">
              <button
                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
                className={`p-2 rounded-lg transition-colors ${
                  currentPage === 1 ? (isDark ? 'text-blue-400/30 cursor-not-allowed' : 'text-gray-400 cursor-not-allowed') : (isDark ? 'text-blue-400 hover:bg-white/5' : 'text-gray-600 hover:bg-gray-100')
                }`}
              >
                <ChevronLeft className="w-4 h-4" />
              </button>
              <span className={`text-sm ${textPrimary}`}>
                Page {currentPage} of {totalPages}
              </span>
              <button
                onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                disabled={currentPage === totalPages}
                className={`p-2 rounded-lg transition-colors ${
                  currentPage === totalPages ? (isDark ? 'text-blue-400/30 cursor-not-allowed' : 'text-gray-400 cursor-not-allowed') : (isDark ? 'text-blue-400 hover:bg-white/5' : 'text-gray-600 hover:bg-gray-100')
                }`}
              >
                <ChevronRight className="w-4 h-4" />
              </button>
            </div>
          </div>
        )}

        {/* Summary Card */}
        <div className={`p-3 mt-4 border ${isDark ? 'bg-blue-600/10 border-blue-500/30' : 'bg-gray-100/60 border-gray-300'} rounded-xl md:p-4 transition-colors duration-300`}>
          <div className="flex items-center gap-2 text-xs md:gap-3 md:text-sm">
            <AlertCircle className={`w-3 h-3 ${isDark ? 'text-blue-400' : 'text-blue-600'} md:w-4 md:h-4`} />
            <span className={isDark ? 'text-blue-300' : 'text-gray-700'}>
              Showing attendance from{' '}
              <span className={`font-medium ${textPrimary}`}>{new Date(fromDate).toLocaleDateString()}</span>
              {' '}to{' '}
              <span className={`font-medium ${textPrimary}`}>{new Date(toDate).toLocaleDateString()}</span>
              {empId !== 'All' && ` for employee ${empId}`}
              {' '}— sorted by date{' '}
              <span className={`font-medium ${textPrimary}`}>
                {dateSortOrder === 'desc' ? '(newest first)' : '(oldest first)'}
              </span>
            </span>
          </div>
        </div>

      </div>
    </div>
  );
};

export default AttendanceManagement;
